export const isEnd = ({ editor }) => {
  const {
    value: {
      focusBlock: { key: focusBlockPreviousKey },
      selection,
    },
  } = editor;

  editor.moveForward(1);
  const {
    value: {
      focusBlock: { key: focusBlockNextKey },
    },
  } = editor;

  /**
   * Focus in the Empty para &
   * at the end of the organizations
   */
  if (
    focusBlockPreviousKey === focusBlockNextKey &&
    editor.value.focusBlock.type === 'paragraph' &&
    !editor.value.focusBlock.text
  ) {
    editor.select(selection);
    return true;
  }

  if (focusBlockPreviousKey !== focusBlockNextKey) {
    editor.select(selection);
    return true;
  }

  editor.select(selection);
  return false;
};

export default (editor) => {
  const {
    value: {
      selection: { isCollapsed },
    },
  } = editor;
  if (isCollapsed) {
    return isEnd({ editor });
  }
  return false;
};
